import { render, staticRenderFns } from "./LessonForm.vue?vue&type=template&id=675aeb0c&scoped=true"
import script from "./LessonForm.vue?vue&type=script&lang=js"
export * from "./LessonForm.vue?vue&type=script&lang=js"
import style0 from "./LessonForm.vue?vue&type=style&index=0&id=675aeb0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675aeb0c",
  null
  
)

export default component.exports